import { render, staticRenderFns } from "./OaTypeIcon.vue?vue&type=template&id=5492f429&scoped=true"
import script from "./OaTypeIcon.vue?vue&type=script&lang=js"
export * from "./OaTypeIcon.vue?vue&type=script&lang=js"
import style0 from "./OaTypeIcon.vue?vue&type=style&index=0&id=5492f429&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5492f429",
  null
  
)

export default component.exports